import { createAction } from '@reduxjs/toolkit'

import {
  REFRESH_CONTRACT_SIGNATURE_PROGRESS_DATA,
  REFRESH_LR_PROGRESS_DATA,
  REFRESH_PROFILING_PROGRESS_DATA,
} from '../config'

export const refreshProfilingProgressData = createAction(REFRESH_PROFILING_PROGRESS_DATA, () => {
  return { payload: null }
})

export const refreshLRProgressData = createAction(REFRESH_LR_PROGRESS_DATA, () => {
  return { payload: null }
})

export const refreshContractSignatureProgressData = createAction(
  REFRESH_CONTRACT_SIGNATURE_PROGRESS_DATA,
  () => ({ payload: null })
)
